import { safeParse } from "./safe-parse";
import { safeStringify } from "./safe-stringify";

const json = {
	safeParse,
	safeStringify,
};

export default json;
